import React from "react";
import SingleImage from "../Gallaryprops";
//2018
import Img181 from "../../../atrimages/pervious event images atri/2018/1.jpg";
import Img182 from "../../../atrimages/pervious event images atri/2018/2.jpg";
import Img183 from "../../../atrimages/pervious event images atri/2018/3.jpg";
import Img184 from "../../../atrimages/pervious event images atri/2018/4.jpg";
import Img185 from "../../../atrimages/pervious event images atri/2018/5.jpg";
import Img186 from "../../../atrimages/pervious event images atri/2018/6.jpg";
import Img187 from "../../../atrimages/pervious event images atri/2018/7.jpg";
import Img188 from "../../../atrimages/pervious event images atri/2018/8.jpg";
import Img189 from "../../../atrimages/pervious event images atri/2018/9.jpg";
import Img1810 from "../../../atrimages/pervious event images atri/2018/10.jpg";
import Img1811 from "../../../atrimages/pervious event images atri/2018/11.jpg";
import Img1812 from "../../../atrimages/pervious event images atri/2018/12.jpg";
import Img1813 from "../../../atrimages/pervious event images atri/2018/13.jpg";
import Img1814 from "../../../atrimages/pervious event images atri/2018/14.jpg";
import Img1815 from "../../../atrimages/pervious event images atri/2018/15.jpg";
import Img1816 from "../../../atrimages/pervious event images atri/2018/16.jpg";
import Img1817 from "../../../atrimages/pervious event images atri/2018/17.jpg";
import Img1818 from "../../../atrimages/pervious event images atri/2018/18.jpg";
import Img1819 from "../../../atrimages/pervious event images atri/2018/19.jpg";
import Img1820 from "../../../atrimages/pervious event images atri/2018/20.jpg";
import Img1821 from "../../../atrimages/pervious event images atri/2018/21.jpg";
import Img1822 from "../../../atrimages/pervious event images atri/2018/22.jpg";
import Img1824 from "../../../atrimages/pervious event images atri/2018/24.jpg";
import Img1825 from "../../../atrimages/pervious event images atri/2018/25.jpg";
import Img1826 from "../../../atrimages/pervious event images atri/2018/26.jpg";
import Img1827 from "../../../atrimages/pervious event images atri/2018/27.jpg";
import Img1828 from "../../../atrimages/pervious event images atri/2018/28.jpg";
import Img1829 from "../../../atrimages/pervious event images atri/2018/29.jpg";
import Img1830 from "../../../atrimages/pervious event images atri/2018/30.jpg";
import Img1831 from "../../../atrimages/pervious event images atri/2018/31.jpg";
import Img1832 from "../../../atrimages/pervious event images atri/2018/32.jpg";
import Img1833 from "../../../atrimages/pervious event images atri/2018/33.jpg";
import Img1834 from "../../../atrimages/pervious event images atri/2018/34.jpg";
import Img1835 from "../../../atrimages/pervious event images atri/2018/35.jpg";
import Img1836 from "../../../atrimages/pervious event images atri/2018/36.jpg";
import Img1837 from "../../../atrimages/pervious event images atri/2018/37.jpg";
import Img1838 from "../../../atrimages/pervious event images atri/2018/38.jpg";
import Img1839 from "../../../atrimages/pervious event images atri/2018/39.jpg";

export default function borealis18() {
  return (
    <div className="YearWise">
      <div className="2018">
        <h2>GLIMPSE OF BOREALIS - 2018</h2>
        <SingleImage gimage={Img181} title="President" />
        <SingleImage gimage={Img182} title="President" />
        <SingleImage gimage={Img183} title="President" />
        <SingleImage gimage={Img184} title="President" />
        <SingleImage gimage={Img185} title="President" />
        <SingleImage gimage={Img186} title="President" />
        <SingleImage gimage={Img187} title="President" />
        <SingleImage gimage={Img188} title="President" />
        <SingleImage gimage={Img189} title="President" />
        <SingleImage gimage={Img1810} title="President" />
        <SingleImage gimage={Img1811} title="President" />
        <SingleImage gimage={Img1812} title="President" />
        <SingleImage gimage={Img1813} title="President" />
        <SingleImage gimage={Img1814} title="President" />
        <SingleImage gimage={Img1815} title="President" />
        <SingleImage gimage={Img1816} title="President" />
        <SingleImage gimage={Img1817} title="President" />
        <SingleImage gimage={Img1818} title="President" />
        <SingleImage gimage={Img1819} title="President" />
        <SingleImage gimage={Img1820} title="President" />
        <SingleImage gimage={Img1821} title="President" />
        <SingleImage gimage={Img1822} title="President" />
        <SingleImage gimage={Img1824} title="President" />
        <SingleImage gimage={Img1825} title="President" />
        <SingleImage gimage={Img1826} title="President" />
        <SingleImage gimage={Img1827} title="President" />
        <SingleImage gimage={Img1828} title="President" />
        <SingleImage gimage={Img1829} title="President" />
        <SingleImage gimage={Img1830} title="President" />
        <SingleImage gimage={Img1831} title="President" />
        <SingleImage gimage={Img1832} title="President" />
        <SingleImage gimage={Img1833} title="President" />
        <SingleImage gimage={Img1834} title="President" />
        <SingleImage gimage={Img1835} title="President" />
        <SingleImage gimage={Img1836} title="President" />
        <SingleImage gimage={Img1837} title="President" />
        <SingleImage gimage={Img1838} title="President" />
        <SingleImage gimage={Img1839} title="President" />
      </div>

      <br />
      <br />
    </div>
  );
}
